// extracted by mini-css-extract-plugin
module.exports = {"printstyle":"NextStepsCommon_printstyle__6wh3t"};